import { Injectable, inject } from '@angular/core';
import { Router } from '@angular/router';
import { Observable, tap, map } from 'rxjs';
import { AccountService } from '../services';

@Injectable({
  providedIn: 'root',
})
export class UserIsNotLoggedInGuard {
  router = inject(Router);
  private accountService = inject(AccountService);

  isLoggedIn(): Observable<boolean> {
    return this.accountService.amILogged().pipe(
      map((resp: any) => {
        return resp ? false : true;
      })
    );
  }

  canActivate(): boolean | Observable<boolean> | Promise<boolean> {
    return this.isLoggedIn().pipe(
      tap((x: any) => {
        if (!x) {
          this.router.navigate(['/']);
        }
      })
    );
  }
}
